import { format } from 'date-fns';

import { t } from 'state/intl/translations';
import { TLoyaltyCooldown } from 'state/loyalty/types';

export const getRewardCooldownAlertMessage = (cooldown: TLoyaltyCooldown): string | undefined =>
  cooldown.isActive
    ? t('rewardAvaiableAt', {
        time: format(cooldown.endsAt, 'h:mm a'),
        defaultValue: 'Redeem at {time}',
      })
    : undefined;
